<template>
    <div v-if="gallery" class="w-full">
      <div class="max-w-7xl mx-auto">
        <carousel
          ref="myCarousel"
          :items-to-show="1"
          :wrap-around="true"
        >
          <slide
            v-for="trip in gallery"
            :key="trip"
            class="py-10 md:py-20"
          >
            <div class="w-full h-full mx-6 md:w-2/3 md:mx-14">
              <!-- mobile-->
              <button class="absolute  z-10 left-6 bottom-2 md:hidden" @click="prev">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.0664 1L1.99977 10.0666L11.0664 19.1333" stroke="#212121" stroke-width="2"/>
                  <line x1="3.13281" y1="9.7334" x2="18.9994" y2="9.7334" stroke="#212121" stroke-width="2"/>
                </svg>
              </button>
              <button @click="next" class="absolute z-10 right-6 bottom-2 md:hidden">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.93359 19.1333L17.0002 10.0667L7.93359 1.00002" stroke="#212121" stroke-width="2"/>
                  <line x1="15.8672" y1="10.3999" x2="0.000569431" y2="10.3999" stroke="#212121" stroke-width="2"/>
                </svg>
              </button>
                <!-- Desktop-->
                <button class="hidden absolute z-10 left-20 top-2/4 md:block" @click="prev">
                    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.0664 1L1.99977 10.0666L11.0664 19.1333" stroke="#212121" stroke-width="2"/>
                        <line x1="3.13281" y1="9.7334" x2="18.9994" y2="9.7334" stroke="#212121" stroke-width="2"/>
                    </svg>
                </button>
              <button @click="next" class="hidden absolute z-10 right-20 top-2/4 md:block">
                    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.93359 19.1333L17.0002 10.0667L7.93359 1.00002" stroke="#212121" stroke-width="2"/>
                        <line x1="15.8672" y1="10.3999" x2="0.000569431" y2="10.3999" stroke="#212121" stroke-width="2"/>
                    </svg>
                </button>
              <figure class="relative aspect-w-16 aspect-h-9">
                <img
                  class="rounded-md object-cover"
                  :src="typeof trip.pivot.media_crop?.url === 'string' ? trip.pivot.media_crop?.url : trip.original_url"
                  :alt="trip.name"
                >
              </figure>
<!--              <div class="w-full mt-5 font-normal text-lg">-->
<!--                  <p>{{ trip.alt }}</p>-->
<!--              </div>-->
            </div>
          </slide>

          <template #addons>
          </template>
        </carousel>
      </div>
    </div>
</template>

<script setup>

import 'vue3-carousel/dist/carousel.css';
import { ref } from 'vue';
import {
  Carousel, Slide,  Navigation,
} from 'vue3-carousel';

const myCarousel = ref(null)

const props = defineProps({
  gallery: {
    type: Array,
    required: true
  }
})


function next() {
    myCarousel.value.next()
}
function prev() {
    myCarousel.value.prev()
}

</script>

